(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cuak-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initRotator(rotator) {
    if (rotator.dataset.cuakReady === '1') return;
    rotator.dataset.cuakReady = '1';
    var slides = rotator.querySelectorAll('.cuak-bar__slide');
    if (slides.length <= 1) return;
    var speed = parseInt(rotator.dataset.speed, 10) || 4000;
    var i = 0;
    setInterval(function () {
      var next = (i + 1) % slides.length;
      // Activar el siguiente ANTES de desactivar el actual para evitar parpadeo en blanco
      slides[next].classList.add('is-active');
      slides[i].classList.remove('is-active');
      i = next;
    }, speed);
  }

  function initCountdown(el) {
    if (el.dataset.cuakReady === '1') return;
    el.dataset.cuakReady = '1';

    var fixed = el.dataset.deadline;
    var rollingHours = parseInt(el.dataset.rollingHours, 10);
    var storageKey = el.dataset.storageKey || 'cuak_bar_deadline';
    var deadline;

    function readDeadline() {
      if (fixed) return new Date(fixed).getTime();
      var stored;
      try { stored = parseInt(localStorage.getItem(storageKey), 10); } catch (e) {}
      var now = Date.now();
      if (!stored || isNaN(stored) || stored < now) {
        var fresh = now + (rollingHours || 12) * 3600 * 1000;
        try { localStorage.setItem(storageKey, fresh); } catch (e) {}
        return fresh;
      }
      return stored;
    }

    deadline = readDeadline();

    var hSeg = el.querySelector('[data-cd-h]');
    var mSeg = el.querySelector('[data-cd-m]');
    var sSeg = el.querySelector('[data-cd-s]');
    var isSegmented = hSeg && mSeg && sSeg;

    function setText(h, m, s) {
      if (isSegmented) {
        hSeg.textContent = pad(h);
        mSeg.textContent = pad(m);
        sSeg.textContent = pad(s);
      } else {
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
    }

    function tick() {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        if (!fixed) {
          deadline = readDeadline();
          remaining = Math.max(0, deadline - Date.now());
        } else {
          setText(0, 0, 0);
          return;
        }
      }
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      setText(h, m, s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-cuak-rotator]').forEach(initRotator);
    root.querySelectorAll('[data-cuak-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Fallback: re-intentar al window load (cubre casos donde el script corre antes que la sección esté en el DOM)
  window.addEventListener('load', function () { init(); });

  // Editor del tema: re-init cuando se actualiza la sección
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuak-hero-revelacion"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cuak-smooth]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuak-imagen-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function openReleasit() {
    var btn = document.querySelector('#_rsi-buy-now-button-overwrite, ._rsi-buy-now-button');
    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }
  function scrollToProduct() {
    var target = document.querySelector('#shopify-section-main, .product-info, [id*="MainProduct"]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    return false;
  }
  function handle(btn) {
    var action = btn.dataset.action || 'releasit';
    if (action === 'releasit') {
      if (!openReleasit()) scrollToProduct();
    } else if (action === 'scroll') {
      scrollToProduct();
    } else if (action === 'url') {
      var url = btn.dataset.target;
      if (url) window.location.href = url;
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cuak-cta]');
    if (!btn) return;
    e.preventDefault();
    handle(btn);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
